import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import DownloadButton from '../../components/DownloadButton/DownloadButton';
import Loader from '../../components/Loader/Loader';
import { ROOT_API_URL, PATH_PREFIX } from '../../core/config/config';
import { ReportDateContext } from '../../core/context/report-date-context';

import Content from '../Content/Content';

// key: 1beabe2478464ae4ba7a67df392dcd5f

function PublicContent(): JSX.Element {
  const history = useHistory();
  const urlQuery = new URLSearchParams(window.location.search);
  const keyParam = urlQuery.get('key') || '';

  if (!keyParam) {
    history.push(`${PATH_PREFIX}/login`);
  }

  window.sessionStorage.setItem('viewAsClient', 'true');
  window.sessionStorage.setItem('key', keyParam);

  const [loading, setLoading] = useState(true);
  const [reportDate, setReportDate] = useState(0);
  const [settlementDate, setSettlementDate] = useState(0);

  useEffect(() => {
    const ac = new AbortController();
    const validateKey = async (key: string) => {
      const apiBase = ROOT_API_URL;
      try {
        const res = await fetch(`${apiBase}/ValidateUserKey`, {
          method: 'POST',
          signal: ac.signal,
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            key,
          }),
        });
        const resData = await res.json();
        setLoading(false);
        return resData;
      } catch (e) {
        history.push(`${PATH_PREFIX}/login`);
      }
      return true;
    };

    validateKey(keyParam).then((response) => {
      if (response.token) {
        window.sessionStorage.setItem('token', response.token);
        window.sessionStorage.setItem('edition', response.typeDay);
        window.sessionStorage.setItem('oppositeEditionKey', response.key);
        setLoading(false);
      }
      setReportDate(response.currentDate);
      setSettlementDate(response.settlementDate);
    });
    return () => ac.abort();
  }, [history, keyParam]);

  return loading ? (
    <Loader />
  ) : (
    <div className="PublicContent">
      <div className="fcc mt-4 pdf-exclude">
        <div className="mx-2">
          <DownloadButton />
        </div>

        <div className="mx-2">
          <button type="button">
            <a
              className="button-text"
              href={`${ROOT_API_URL}/TotalReport?Key=${keyParam}`}
              target="_blank"
              rel="noreferrer"
            >
              View PDF
            </a>
          </button>
        </div>
      </div>

      <ReportDateContext.Provider
        value={{ reportDate: new Date(reportDate), settlementDate: new Date(settlementDate) }}
      >
        <Content />
      </ReportDateContext.Provider>
    </div>
  );
}

export default PublicContent;
